import { axiosNTL } from '../../../services/axios';

import ContentStatusData from "../types/ContentStatusData";


const list = () => Promise.resolve()
    .then(() => {
        let cs: ContentStatusData[] = [
            {
                _id: "",
                name: "Published",
                code: "PUBLISHED"
            },
            {
                _id: "",
                name: "In Review",
                code: "inReview"
            },
            {
                _id: "",
                name: "Draft",
                code: "DRAFT"
            },
            {
                _id: "",
                name: "Deleted",
                code: "DELETED"
            },
            {
                _id: "",
                name: "Planned",
                code: "PLANNED"
            },
        ];

        return Promise.resolve(cs);
    })

const getStatusForValidation = (tab: string) => axiosNTL
    .get(`/content-validation/content-status?contentMenu=${tab}`)
    .then((res: any) => {
        return Promise.resolve(res.responseObject || []);
    });


export const contentStatusService = {
    list,
    getStatusForValidation
};